import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PrimeNG } from 'primeng/config';


@Component({
    selector: 'app-root',
    imports: [RouterModule],
    template: ` <router-outlet /> `
})
export class AppComponent implements OnInit{

  constructor(private primeng: PrimeNG) {}

    ngOnInit() {
        this.primeng.ripple.set(true);
    }
}
